<template>
  <div class="flex justify-center items-center w-full h-full">
    <!-- <vs-button v-if="this.params.data.actionData.toggle" color="success" type="flat" @click="handleChange"
      >Activate</vs-button
    >
    <vs-button
      v-else
      color="danger"
      type="flat"
      @click="handleChange"
      >Deactivate</vs-button
    > -->
    <span style="font-size: 12px;" class="cstm_badge danger" v-if="!this.params.data.actionData.toggle">Inactive</span>
    <span style="font-size: 12px;" class="cstm_badge success" v-else>Active</span>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { ToggleButton } from 'vue-js-toggle-button'

import { activeDeactiveLeads } from '@/api/leads'

export default {
  name: 'ToggleActions',
  components: {
    ToggleButton
  },
  mounted () {
    console.log()
    this.action = this.params.data.actionData
    this.toggle = this.params.data.actionData.toggle
  },
  data () {
    return {
      action: {},
      toggle: false
    }
  },
  methods: {
    ...mapActions(
      ['SET_DELETE_ID', 'SET_VIEW_LEADS_SIDEBAR', 'SET_VIEW_LEADS_SIDEBAR_DATA', 'SET_LEADS_TOGGLE_DATA']
    ),
    async handleChange () {
      this.params.data.actionData.toggle = !this.params.data.actionData.toggle
      this.params.data.is_active = this.params.data.actionData.toggle ? 1 : 0
      try {
        const leads_id = this.params.data.leads_id
        const payload = {
          leads_id,
          type: this.params.data.actionData.toggle ? 1 : 0
        }
        activeDeactiveLeads(payload)
        const storePayload = {
          row_details: this.params.data,
          toggle: this.params.data.actionData.toggle
        }
        this.SET_LEADS_TOGGLE_DATA(storePayload)
        const msg = this.params.data.actionData.toggle ? 'Lead activated successfully' : 'Lead deactivated successfully'
        this.$vs.notify({
          title: 'Success',
          text: msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
      } catch (e) {

        this.$vs.notify({
          title: 'Warning',
          text: e,
          ...this.warnProp()
        })
      }
    }
  }
}
</script>
